// extracted by mini-css-extract-plugin
export var bubble = "_z-0";
export var container = "_z-3";
export var contrastBorder = "_z-4";
export var greyOut = "_z-2";
export var initialsWrapper = "_z-1";
export var large = "_z-9";
export var medium = "_z-8";
export var mediumSmall = "_z-7";
export var mediumSmallMedium = "_z-c";
export var micro = "_z-5";
export var small = "_z-6";
export var tiny = "_z-b";
export var xTiny = "_z-a";